export const validateUsernameAlphabet = (usernameAlphabet: string) => {
    return /^[a-zA-Z ]+$/.test(usernameAlphabet)
}

export const validateAuthorityLevel = (level: string) => {
    try {
        const level_num = Number(level)
        if (!Number.isInteger(level_num)) return false
        if (1 <= level_num && level_num <= 9) return true
        return false
    }
    catch {
        return false
    }
}

export const validateUserId = (userid: string) => {
    // 英数字と一部記号(メールアドレスに一般的に使用される記号)のみ許可
    return /^[a-zA-Z0-9\-\._@]+$/.test(userid)
}

export const validatePassword = (password: string) => {
    // ASCII 33-126の範囲を許可([!-~]と等価)
    return /^[a-zA-Z0-9!-/:-@[-`{-~]+$/.test(password)
}